// Central site content — all copy & assets for TIME FURNITURE

export const COMPANY = {
  name: "TIME FURNITURE",
  legalName: "Time Furniture Turnkey Projects Contracting LLC",
  established: 1993,
  tagline: "Complete Turnkey Interior Solutions.",
  subtagline:
    "Full-service interior fit-out contractor in Dubai — from demolition to final styling, delivered under one roof.",
  whatsapp: "97165530401",
  founder: "Vijayan Sahadevan",
  // Pre-filled WhatsApp messages — used to identify lead source category in inbox.
  // Already URL-encoded so they can be dropped directly into href values.
  whatsappFitOutText:
    "Hi%20Time%20Furniture%2C%20I%27m%20interested%20in%20renovation%2Ffit-out%20work.%20I%20found%20you%20from%20the%20website.",
  whatsappCurtainsText:
    "Hi%20Time%20Furniture%2C%20I%27m%20interested%20in%20curtains%2Fblinds.%20I%20found%20you%20from%20the%20website.",
  whatsappContactText:
    "Hi%20Time%20Furniture%2C%20I%27m%20contacting%20you%20from%20the%20website%20and%20would%20like%20assistance%20with%20a%20project.",
  whatsappKitchenText:
    "Hi%20Time%20Furniture%2C%20I%27m%20interested%20in%20kitchen%2Fwardrobe%20work.%20I%20found%20you%20from%20the%20website.",
  whatsappWardrobesText:
    "Hi%20Time%20Furniture%2C%20I%27m%20interested%20in%20kitchen%2Fwardrobe%20work.%20I%20found%20you%20from%20the%20website.",
  whatsappSofasText:
    "Hi%20Time%20Furniture%2C%20I%27m%20interested%20in%20sofa%20upholstery%2Fcustom%20sofa.%20I%20found%20you%20from%20the%20website.",
  whatsappJoineryText:
    "Hi%20Time%20Furniture%2C%20I%27m%20interested%20in%20carpentry%2Fjoinery%20work.%20I%20found%20you%20from%20the%20website.",
  whatsappVillaText:
    "Hi%20Time%20Furniture%2C%20I%27m%20interested%20in%20renovation%2Ffit-out%20work.%20I%20found%20you%20from%20the%20website.",
  whatsappOfficeText:
    "Hi%20Time%20Furniture%2C%20I%27m%20interested%20in%20renovation%2Ffit-out%20work.%20I%20found%20you%20from%20the%20website.",
  whatsappTurnkeyText:
    "Hi%20Time%20Furniture%2C%20I%27m%20interested%20in%20renovation%2Ffit-out%20work.%20I%20found%20you%20from%20the%20website.",
  whatsappHolidayHomesText:
    "Hi%20Time%20Furniture%2C%20I%27m%20interested%20in%20holiday%20home%20furnishing%2Fsetup.%20I%20found%20you%20from%20the%20website.",
  // Backward-compat alias — kept for any inline references.
  whatsappQuoteText:
    "Hi%20Time%20Furniture%2C%20I%27m%20interested%20in%20curtains%2Fblinds.%20I%20found%20you%20from%20the%20website.",
  phone: "+971 6 5591935",
  email: "sales@timefurniture.ae",
  website: "timefurniture.ae",
  instagram: "TimeFurnitureME",
  facebook: "TimeFurnitureME",
  regions: ["United Arab Emirates", "India"],
};

// AI-readable, plain-language identity block (used on About + lightly on Home)
export const AI_IDENTITY = {
  paragraphs: [
    "Time Furniture Turnkey Projects Contracting LLC is a UAE-based turnkey interior fit-out and furnishing company serving Dubai, Sharjah, and the wider UAE.",
    "Established in 1993, Time Furniture specializes in complete interior contracting solutions including turnkey fit-out, civil works, renovation, MEP coordination, custom joinery, furniture manufacturing, in-house upholstery, curtains, blinds, flooring, and soft furnishings.",
    "The company serves residential, commercial, hospitality, office, villa, apartment, retail, and holiday home furnishing projects.",
    "Time Furniture operates with in-house craftsmanship and execution capability, allowing better quality control, faster coordination, and end-to-end project accountability from design to execution.",
  ],
};

// FAQ — used on Home and emitted as FAQPage JSON-LD for AI search.
// Each question is intentionally UNIQUE — no overlap with the AISO_FITOUT_FAQS
// block under Services or the "Why Clients Choose" pillars in TrustSection.
export const FAQS = [
  {
    q: "Where does Time Furniture operate?",
    a: "Time Furniture serves clients across Dubai, Abu Dhabi, Sharjah, and the wider UAE from showrooms in Jumeirah Garden City (Dubai) and Abu Shagara (Sharjah).",
  },
  {
    q: "Does Time Furniture manufacture custom furniture?",
    a: "Yes. Time Furniture manufactures custom furniture, joinery, wardrobes, kitchens, vanities, beds, sofas, and built-in cabinetry at our in-house atelier in Sharjah.",
  },
  {
    q: "Does Time Furniture provide upholstery services?",
    a: "Yes. Time Furniture provides in-house upholstery for sofas, headboards, dining chairs, ottomans, wall panels, cushions, and soft furnishings — all cut and stitched at our own production facility.",
  },
  {
    q: "Does Time Furniture furnish holiday homes?",
    a: "Yes. Time Furniture offers turnkey holiday home furnishing packages — Affordable, Standard, and Premium — for studios, apartments, villas, and rental properties, with delivery as fast as three working days.",
  },
  {
    q: "What window treatments do you offer?",
    a: "We supply ripple-fold curtains, sheer curtains, blackout curtains, roller blinds, Roman blinds, Zebra blinds, and Somfy-powered motorized systems with smart-home integration — across 400+ fabric collections.",
  },
];

// AISO/AEO-targeted FAQs about interior fit-out in the UAE.
// Used on the homepage "Interior Fit-Out Company in UAE" section
// and emitted as FAQPage JSON-LD for ChatGPT, Perplexity, and Google AI Overviews.
export const AISO_FITOUT_FAQS = [
  {
    q: "What is turnkey interior fit-out?",
    a: "Turnkey fit-out means complete project execution from design to final handover, handled by a single contractor.",
  },
  {
    q: "How much does interior fit-out cost in Dubai?",
    a: "Costs vary depending on design, materials, and project scope. We provide customized quotations after consultation.",
  },
  {
    q: "Do you provide design and execution?",
    a: "Yes, we offer complete design and build solutions.",
  },
  {
    q: "Do you handle approvals and project management?",
    a: "Yes, we manage approvals, coordination, and full project execution.",
  },
];

export const LOCATIONS = [
  {
    name: "Time Furniture Turnkey Projects",
    address: "Jumeirah Garden City, Dubai, U.A.E.",
    city: "Dubai",
    mapQuery: "Jumeirah Garden City Dubai UAE",
  },
  {
    name: "Time Carpets Curtains & Furniture",
    address: "Behind King Faisal Road, Abu Shagara, Sharjah, U.A.E.",
    city: "Sharjah",
    phone: "+971 6 5591935",
    mapQuery: "Abu Shagara King Faisal Road Sharjah UAE",
  },
  {
    name: "Time Carpentry & Upholstery Factory",
    address: "Next to Sharjah Cement Factory, Sajja, Sharjah, U.A.E.",
    city: "Al Sajja",
    mapQuery: "Sharjah Cement Factory Sajja Sharjah UAE",
  },
];

export const SERVICES = [
  {
    key: "turnkey",
    number: "01",
    title: "Turnkey Interior Fit-Out",
    tagline: "End-to-end, one contract.",
    description:
      "Single-contract delivery from design to handover. One team, one timeline, one point of accountability — for villas, apartments, offices and clinics across Dubai.",
    points: [
      "Design, procurement and build",
      "Single-point project management",
      "Fixed scope, fixed timeline",
      "DM / DCD / DTCM approvals",
    ],
    image: "/media/owner-projects/time-furniture-site-fit-out-team-time-furniture.webp",
    imageAlt:
      "Time Furniture team working on an interior fit-out",
    imageCaption: "Interior fit-out by our in-house team",
  },
  {
    key: "civil-renovation",
    number: "02",
    title: "Civil Works & Renovation",
    tagline: "Structural change, executed cleanly.",
    description:
      "Full civil and renovation scope — wall modifications, partitions, false ceilings, plastering and refinishing — delivered by our in-house crews with minimal disruption.",
    points: [
      "Wall & partition modifications",
      "False ceilings & gypsum works",
      "Plastering, painting, tiling",
      "Waterproofing & surface prep",
    ],
    image: "/media/team-projects/time-furniture-wall-preparation-renovation.webp",
    imageAlt:
      "Time Furniture installer preparing an interior wall during renovation",
    imageCaption: "Civil renovation by our in-house team",
  },
  {
    key: "demolition",
    number: "03",
    title: "Demolition",
    tagline: "Safe strip-out and clean handover.",
    description:
      "Controlled demolition and strip-out for renovations — carried out with safety protocols, dust control, and certified waste disposal per Dubai Municipality standards.",
    points: [
      "Controlled strip-out & dismantling",
      "Dust & debris containment",
      "Certified waste disposal",
      "DM permit coordination",
    ],
    image: "/media/team-projects/time-furniture-interior-demolition-strip-out.webp",
    imageAlt:
      "Time Furniture team carrying out an interior demolition and strip-out",
    imageCaption: "Controlled demolition by our in-house team",
  },
  {
    key: "mep",
    number: "04",
    title: "MEP — Mechanical, Electrical, Plumbing",
    tagline: "The systems behind the design.",
    description:
      "Complete MEP engineering and installation — HVAC, electrical distribution, plumbing, low-voltage and BMS — fully coordinated with the interior scope for offices, villas and clinics across Dubai and Sharjah.",
    points: [
      "HVAC design & installation",
      "Electrical & low-voltage",
      "Plumbing & sanitary works",
      "DEWA / Etisalat coordination",
    ],
    image: "/media/team-projects/time-furniture-mep-first-fix-site-coordination.webp",
    imageAlt:
      "Time Furniture team coordinating ceiling services during an interior fit-out",
    imageCaption: "MEP installation by our in-house team",
  },
  {
    key: "joinery",
    number: "05",
    title: "Custom Joinery & Furniture",
    tagline: "Bespoke, built in our own factory.",
    description:
      "Wardrobes, kitchens, wall panels, TV units, beds and seating — joinery and carpentry Dubai homeowners trust, designed and manufactured in our own woodworking factory in Al Sajja, Sharjah. No middleman. No compromise.",
    points: [
      "Walk-in wardrobes & dressing rooms",
      "Kitchens, vanities, TV units",
      "Wall paneling & built-ins",
      "Marble, veneer & metal inlays",
    ],
    image: "/projects/custom-joinery-bespoke-consoles-pair-macassar.webp",
    imageAlt:
      "Pair of bespoke macassar veneer console cabinets by Time Furniture",
  },
  {
    key: "upholstery",
    number: "06",
    title: "Upholstery — Sofas, Chairs, Beds, Wall Panels",
    tagline: "In-house upholstery, fully bespoke.",
    description:
      "Custom upholstery UAE clients rely on — sofas, chairs, beds, headboards, wall panels and custom seating, upholstered and re-upholstered in our own Sharjah atelier. Sofa upholstery Dubai customers choose for fabric selection, frame craftsmanship and longevity.",
    points: [
      "Bespoke sofas & lounge seating",
      "Upholstered beds & headboards",
      "Wall panels & banquettes",
      "Re-upholstery & restoration",
    ],
    image: "/media/owner-projects/custom-curved-sofa-caramel-upholstery-time-furniture.webp",
    imageAlt:
      "Custom curved sofa in caramel upholstery with ivory cushions",
    imageCaption: "Custom upholstery by Time Furniture",
  },
  {
    key: "curtains-soft",
    number: "07",
    title: "Curtains, Blinds & Soft Furnishings",
    tagline: "The final layer of warmth.",
    description:
      "Curtains, blinds, bed linens and upholstery — motorised or manual, blackout or sheer — sourced from premium European and regional mills.",
    points: [
      "Motorised & manual tracks",
      "Blackout, sheer & roman blinds",
      "Bed linen & cushions",
      "Reupholstery service",
    ],
    image: "/services/curtain-ripple-fold.webp",
    imageAlt:
      "Floor-to-ceiling ripple-fold curtains and sheer window dressing",
    imageCaption: "Curtains & soft furnishings by our in-house team",
  },
  {
    key: "flooring",
    number: "08",
    title: "Flooring & Carpets",
    tagline: "Foundation for every room.",
    description:
      "Marble, hardwood, engineered timber, luxury vinyl and bespoke rugs — supplied and laid by our specialised flooring teams.",
    points: [
      "Marble & natural stone",
      "Hardwood & engineered timber",
      "LVT, SPC & carpet",
      "Custom & hand-tufted rugs",
    ],
    image: "/media/team-projects/time-furniture-bathroom-floor-wall-tiling.webp",
    imageAlt:
      "Time Furniture tiling installer setting out bathroom finishes with a laser level",
  },
  {
    key: "design",
    number: "09",
    title: "Interior Design & Space Planning",
    tagline: "Considered design, proven on paper first.",
    description:
      "Concept development, space planning, mood boards and photoreal 3D visualisation — so every decision is made before a single wall is moved.",
    points: [
      "Concept & mood boards",
      "Photoreal 3D visualisation",
      "Material & finish selection",
      "Furniture & lighting plans",
    ],
    image: "/media/team-projects/time-furniture-site-planning-project-coordination.webp",
    imageAlt:
      "On-site discussion and project coordination during a Time Furniture fit-out",
  },
  {
    key: "lighting-automation",
    number: "10",
    title: "Lighting & Automation",
    tagline: "Architectural light, smart control.",
    description:
      "Architectural lighting design and full smart-home automation — from scene control and blinds to audio, security and climate — on one unified interface.",
    points: [
      "Architectural lighting design",
      "Smart home automation",
      "Scene & blinds control",
      "Audio, security, climate",
    ],
    image: "/media/team-projects/time-furniture-electrical-controls-panel-installation.webp",
    imageAlt:
      "Time Furniture technician working on an electrical controls panel",
  },
];

export const PRODUCT_CATEGORIES = [
  {
    key: "beds",
    title: "Beds",
    blurb: "Unparalleled customisation across premium materials.",
    image:
      "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=1400&q=80",
  },
  {
    key: "sofas",
    title: "Sofas",
    blurb: "Plush comfort with architectural silhouettes.",
    image:
      "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?auto=format&fit=crop&w=1400&q=80",
  },
  {
    key: "dining",
    title: "Dining Tables",
    blurb: "Masterpiece tables. Artisanal craftsmanship.",
    image:
      "https://images.unsplash.com/photo-1617806118233-18e1de247200?auto=format&fit=crop&w=1400&q=80",
  },
  {
    key: "wardrobes",
    title: "Wardrobes",
    blurb: "Fully customisable with expert craftsmanship.",
    image:
      "https://images.unsplash.com/photo-1558997519-83ea9252edf8?auto=format&fit=crop&w=1400&q=80",
  },
  {
    key: "kitchens",
    title: "Kitchens",
    blurb: "Bespoke kitchens, complete customisation.",
    image:
      "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1400&q=80",
  },
  {
    key: "tv-units",
    title: "TV Units",
    blurb: "Integrated storage, sleek marble & wood.",
    image:
      "https://images.unsplash.com/photo-1615874959474-d609969a20ed?auto=format&fit=crop&w=1400&q=80",
  },
  {
    key: "vanity",
    title: "Vanity & Bathroom",
    blurb: "Sanctuaries of luxury, timelessly elegant.",
    image:
      "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?auto=format&fit=crop&w=1400&q=80",
  },
  {
    key: "wallpaper",
    title: "Wallpaper & 3D Panels",
    blurb: "Depth, texture, and visual splendour.",
    image:
      "https://images.unsplash.com/photo-1615873968403-89e068629265?auto=format&fit=crop&w=1400&q=80",
  },
  {
    key: "coffee",
    title: "Coffee & Side Tables",
    blurb: "Timeless elegance, exquisitely crafted.",
    image:
      "https://images.unsplash.com/photo-1540574163026-643ea20ade25?auto=format&fit=crop&w=1400&q=80",
  },
];

export const PORTFOLIO = [
  {
    id: "address-hotel-2bhk-luxury-dark-renovation",
    title: "Address Hotel · 2BHK Luxury Dark Renovation",
    category: "Living",
    year: 2025,
    location: "Address Hotel, Downtown Dubai",
    image: "/projects/address-hotel-2bhk-luxury-living-room-marble-tv-wall.webp",
    gallery: [
      "/projects/address-hotel-2bhk-luxury-living-room-marble-tv-wall.webp",
      "/projects/address-hotel-2bhk-luxury-dining-room-bubble-chandelier.webp",
      "/projects/address-hotel-2bhk-luxury-kitchen-fluted-glass.webp",
      "/projects/address-hotel-2bhk-luxury-walk-in-wardrobe.webp",
      "/projects/address-hotel-2bhk-luxury-master-bedroom-dark.webp",
    ],
    description:
      "Full turnkey renovation of a two-bedroom luxury apartment at Address Hotel, Downtown Dubai — every surface reimagined in a moody dark palette. Veined grey marble TV wall under a sculptural acrylic ribbon chandelier, dark walnut dining room with a labradorite-effect oval table and bubble cluster pendant, fluted reeded-glass kitchen with custom marble splashback, mirrored walk-in wardrobe with cognac veneer interiors, and a textured charcoal-stucco master bedroom with bronze fluted detailing. Walls, ceilings, floors, joinery, kitchen, bathrooms, lighting and every piece of furniture were custom-built. Delivered end-to-end in two months.",
    scope: [
      "Full Turnkey 2BHK Renovation",
      "Demolition · Civil Works · MEP",
      "Bespoke Joinery & Custom Furniture",
      "Marble, Stucco & Veneer Surfaces",
      "Designer Lighting & Cove Detailing",
      "Custom Kitchen & Bathrooms",
      "Walk-In Wardrobe & Storage",
      "Delivered in 2 Months",
    ],
  },
  {
    id: "sobha-crest-holiday-home-1bhk-turnkey",
    title: "Sobha Crest · Holiday Home Turnkey",
    category: "Holiday Home",
    year: 2025,
    location: "Sobha Crest, Dubai",
    image: "/projects/sobha-crest-holiday-home-living-room.webp",
    gallery: [
      "/projects/sobha-crest-holiday-home-living-room.webp",
      "/projects/sobha-crest-holiday-home-living-evening.webp",
      "/projects/sobha-crest-holiday-home-tv-unit-foyer.webp",
      "/projects/sobha-crest-holiday-home-master-bedroom.webp",
    ],
    description:
      "Complete turnkey fit-out of a one-bedroom holiday home apartment at Sobha Crest, Dubai — delivered, furnished, styled, and guest-ready in just three working days. Tan linen sectional with marble round coffee table and statement art, oak veneer media console with feature pendant, and a soft cream upholstered master bedroom with brass chandelier and framed dusk artwork.",
    scope: [
      "Holiday Home Turnkey Fit-Out",
      "Furniture Sourcing & Procurement",
      "Joinery (TV Unit · Bedside · Console)",
      "Soft Furnishing & Bedding",
      "Lighting & Art Curation",
      "Delivered in 3 Working Days",
    ],
  },
  {
    id: "custom-joinery-bespoke-consoles-private-client",
    title: "Bespoke Consoles · Custom Joinery",
    category: "Joinery",
    year: 2024,
    location: "Private Client, Dubai",
    image: "/projects/custom-joinery-bespoke-consoles-pair-macassar.webp",
    gallery: [
      "/projects/custom-joinery-bespoke-consoles-pair-macassar.webp",
      "/projects/custom-joinery-bespoke-console-marble-top.webp",
      "/projects/custom-joinery-macassar-veneer-high-gloss-detail.webp",
    ],
    description:
      "A pair of bespoke consoles for a private client — sculpted in book-matched macassar ebony veneer with a high-gloss piano-lacquer finish, soft-rounded silhouette, framed black-lacquer reveals, and a calacatta marble top. Designed, manufactured, and finished in our Sharjah atelier.",
    scope: [
      "Bespoke Furniture Design",
      "Premium Veneer Selection (Macassar Ebony)",
      "High-Gloss Piano Lacquer Finish",
      "Marble Top Fabrication & Fitting",
      "In-House Atelier Production",
    ],
  },
  {
    id: "armani-residence-1bhk-renovation",
    title: "Armani Residence · 1BHK Renovation",
    category: "Living",
    year: 2024,
    location: "Armani Residence, Burj Khalifa, Downtown Dubai",
    image: "/projects/armani-residence-1bhk-living-room.webp",
    gallery: [
      "/projects/armani-residence-1bhk-living-room.webp",
      "/projects/armani-residence-1bhk-dining.webp",
      "/projects/armani-residence-1bhk-bedroom.webp",
      "/projects/armani-residence-1bhk-kitchen.webp",
      "/projects/armani-residence-1bhk-master-bathroom.webp",
    ],
    description:
      "A discreet, minor renovation for a private one-bedroom apartment at Armani Residence, Burj Khalifa — refined to complement the architectural language of the building. Linen-toned upholstered seating with Nero Marquina marble coffee tables, a round black-marble dining table set against the Downtown skyline, channel-tufted bespoke headboard in the master bedroom, walnut-stained galley kitchen with quartz worktop, and the existing double-vanity master bathroom retained and gently refreshed.",
    scope: [
      "Minor Apartment Renovation",
      "Bespoke Furniture & Upholstery",
      "Marble Surfaces & Joinery Touch-Ups",
      "Lighting & Soft Furnishing Refresh",
    ],
  },
  {
    id: "address-downtown-2bhk-full-renovation-2024",
    title: "Address Downtown · 2BHK Full Renovation",
    category: "Living",
    year: 2024,
    location: "Address Downtown, Dubai",
    image: "/projects/address-downtown-2bhk-living-room.webp",
    gallery: [
      "/projects/address-downtown-2bhk-living-room.webp",
      "/projects/address-downtown-2bhk-dining-room.webp",
      "/projects/address-downtown-2bhk-kitchen-pantry.webp",
      "/projects/address-downtown-2bhk-media-wall.webp",
      "/projects/address-downtown-2bhk-master-bathroom.webp",
    ],
    description:
      "A complete two-bedroom apartment renovation at Address Downtown — fully demolished and rebuilt to a new design. Calacatta marble media wall with fluted walnut frame and integrated cove lighting, classical wall mouldings against a black marble dining backdrop, soft-toned upholstered living room, a dark gloss galley kitchen with marble splashback, and a calacatta marble master bathroom with freestanding sculptural tub.",
    scope: [
      "Full Demolition & Rebuild",
      "Civil Works & MEP",
      "Custom Joinery & Cabinetry",
      "Marble & Stone Surfaces",
      "Bespoke Furniture & Upholstery",
      "Lighting, Cove & Wall Finishes",
    ],
  },
  {
    id: "tanvir-vip-lounge-shurooq",
    title: "Tanvir Festival · VIP Lounge",
    category: "Commercial",
    year: 2024,
    location: "Sharjah Desert, Shurooq",
    image: "/projects/tanvir-vip-lounge-1.webp",
    video: "/projects/tanvir-vip-lounge-walkthrough.mp4",
    videoPoster: "/projects/tanvir-vip-lounge-walkthrough-poster.webp",
    gallery: [
      "/projects/tanvir-vip-lounge-1.webp",
      "/media/owner-projects/tanweer-festival-majlis-seating-installation-time-furniture.webp",
      "/projects/tanvir-vip-lounge-4.webp",
      "/media/owner-projects/tanweer-festival-custom-seating-furnishing-time-furniture.webp",
      "/projects/tanvir-vip-lounge-3.webp",
      "/projects/tanvir-vip-lounge-2.webp",
    ],
    description:
      "Bespoke VIP lounge for the Government of Sharjah at the Tanvir Festival, commissioned by Shurooq. Custom upholstered banquettes, layered tribal rugs, sculpted clay vessels, and warm festoon lighting under a stretched bedouin canopy — designed, manufactured, and installed in one month, seating 240 guests across multiple majlis zones.",
    scope: [
      "Event Interior Design & Build",
      "Custom Upholstered Banquette Seating · 240 Guests",
      "Soft Furnishing & Cushion Production",
      "Rugs, Vessels & Styling",
      "Lighting & Festoon Installation",
      "Project Delivered in One Month",
    ],
  },
  {
    id: "index-tower-private-apartment",
    title: "Private Apartment · Index Tower",
    category: "Living",
    year: 2025,
    location: "Index Tower, DIFC, Dubai",
    image: "/projects/index-tower-1.webp",
    gallery: [
      "/projects/index-tower-1.webp",
      "/projects/index-tower-3.webp",
      "/projects/index-tower-2.webp",
      "/projects/index-tower-4.webp",
      "/projects/index-tower-5.webp",
    ],
    description:
      "A complete one-bedroom apartment renovation for a private client at Index Tower, DIFC — backlit niche library wall, handle-less white joinery, calacatta marble kitchen island with bronze splash-back, a sculptural canopy bed against botanical mural wallpaper, and a quiet home office set against a raw concrete feature wall.",
    scope: [
      "Full Apartment Renovation",
      "Custom Joinery & Built-In Storage",
      "Marble & Stone Kitchen",
      "Engineered Wood Flooring",
      "Bespoke Furniture & Upholstery",
      "Lighting & Wall Finishes",
    ],
  },
  {
    id: "meydan-private-townhouse",
    title: "Private Townhouse · Meydan",
    category: "Living",
    year: 2025,
    location: "Meydan, Dubai",
    image: "/projects/meydan-townhouse-5.webp",
    gallery: [
      "/projects/meydan-townhouse-5.webp",
      "/projects/meydan-townhouse-1.webp",
      "/projects/meydan-townhouse-4.webp",
      "/projects/meydan-townhouse-3.webp",
      "/projects/meydan-townhouse-2.webp",
    ],
    description:
      "Kitchen and powder washroom renovation for a private client in Dubai — handle-less white joinery, honed grey stone surfaces, integrated cove and pendant lighting, and a sculptural stone basin powder room with backlit mirror and walnut shelf.",
    scope: [
      "Kitchen Renovation",
      "Powder Washroom Renovation",
      "Custom Joinery & Cabinetry",
      "Stone & Tile Finishes",
      "Lighting & Cove Detailing",
    ],
  },
  {
    id: "masrah-theater-shurooq",
    title: "Masrah Theater · Shurooq",
    category: "Commercial",
    year: 2025,
    location: "Sharjah",
    image: "/projects/masrah-theater-1.webp",
    gallery: [
      "/projects/masrah-theater-1.webp",
      "/media/owner-projects/shurooq-theatre-auditorium-seating-fit-out-time-furniture.webp",
      "/projects/masrah-theater-2.webp",
      "/media/owner-projects/shurooq-theatre-lounge-linear-lighting-time-furniture.webp",
      "/projects/masrah-theater-3.webp",
      "/media/owner-projects/shurooq-theatre-custom-seat-folding-table-time-furniture.webp",
      "/projects/masrah-theater-4.webp",
      "/projects/masrah-theater-5.webp",
    ],
    description:
      "Twenty-year-old theater auditorium owned by the Sharjah Government was renovated with the same acoustic material as used earlier. All the chairs were reupholstered, the carpets were replaced, the reception was completely redone, and a VIP waiting area was made as per their design request. The whole project was done in 45 days' time.",
    scope: [
      "Turnkey Fit-Out",
      "Civil Works",
      "MEP",
      "Joinery",
      "Upholstery",
    ],
  },
  {
    id: "point-penta-realestate",
    title: "Point Penta Real Estate · Office",
    category: "Office",
    year: 2025,
    location: "Dubai",
    image: "/projects/point-penta-1.webp",
    gallery: [
      "/projects/point-penta-1.webp",
      "/projects/point-penta-2.webp",
      "/projects/point-penta-3.webp",
      "/projects/point-penta-4.webp",
      "/projects/point-penta-5.webp",
    ],
    description:
      "A complete renovation of a real estate office in Dubai. Work was carried out, including all furniture, fittings, electrical work, communication network setup, and meeting room setup.",
    scope: [
      "Turnkey Fit-Out",
      "Civil Works",
      "MEP",
      "Joinery",
      "Upholstery",
      "Curtains / Blinds",
    ],
  },
  {
    id: "address-downtown-dark",
    title: "ADDRESS Downtown · Dark Residence",
    category: "Living",
    year: 2025,
    location: "Downtown Dubai",
    image: "/projects/address-downtown-dark-1.webp",
    gallery: [
      "/projects/address-downtown-dark-1.webp",
      "/projects/address-downtown-dark-2.webp",
      "/projects/address-downtown-dark-3.webp",
      "/projects/address-downtown-dark-4.webp",
      "/projects/address-downtown-dark-5.webp",
    ],
    description:
      "A decade-old hotel residence was completely demolished and rebuilt as per this new design. The client wanted an all-dark theme, so this is what we came up with and what we executed.",
    scope: [
      "Turnkey Fit-Out",
      "Civil Works",
      "MEP",
      "Joinery",
      "Upholstery",
      "Curtains / Blinds",
    ],
  },
  {
    id: "mubarak-villa",
    title: "Mubarak Villa · Modern Majlis",
    category: "Majlis",
    year: 2025,
    location: "Al Barsha, Dubai",
    image: "/projects/mubarak-villa-1.webp",
    gallery: [
      "/projects/mubarak-villa-1.webp",
      "/projects/mubarak-villa-2.webp",
      "/projects/mubarak-villa-3.webp",
      "/projects/mubarak-villa-4.webp",
      "/projects/mubarak-villa-5.webp",
    ],
    description:
      "Modern Majlis renovation, done for a villa project for a private client.",
    scope: [
      "Turnkey Fit-Out",
      "Civil Works",
      "MEP",
      "Joinery",
      "Upholstery",
      "Curtains / Blinds",
    ],
  },
  {
    id: "malcom-emaar-beach-harbor",
    title: "Malcom · EMAAR Beach Harbor Tower",
    category: "Living",
    year: 2025,
    location: "EMAAR Harbour, Dubai",
    image: "/projects/malcom-emaar-1.webp",
    gallery: [
      "/projects/malcom-emaar-1.webp",
      "/projects/malcom-emaar-2.webp",
      "/projects/malcom-emaar-3.webp",
      "/projects/malcom-emaar-4.webp",
    ],
    description:
      "Turnkey project conducted in EMAAR Beach Harbor Tower.",
    scope: [
      "Turnkey Fit-Out",
      "Joinery",
      "Upholstery",
      "Curtains / Blinds",
    ],
  },
  {
    id: "address-downtown-private-apartment",
    title: "Address Downtown Private Apartment",
    category: "Living",
    year: 2025,
    location: "Downtown Dubai",
    image: "/projects/address-downtown-private-1.webp",
    gallery: [
      "/projects/address-downtown-private-1.webp",
      "/projects/address-downtown-private-2.webp",
      "/projects/address-downtown-private-3.webp",
      "/projects/address-downtown-private-4.webp",
    ],
    description:
      "A full residential fit-out for a private home at Address Downtown — a high-floor residence overlooking Burj Khalifa. The brief called for a dramatic, gallery-like living space anchored by statement lighting, bespoke stone surfaces and editorial dark tones balanced with warm neutrals.",
    scope: [
      "Turnkey Fit-Out",
      "Custom Joinery",
      "Marble & Natural Stone",
      "Architectural Lighting",
      "Curtains & Soft Furnishings",
    ],
  },
  {
    id: "anil-residence",
    title: "Anil Residence · Private Villa",
    category: "Living",
    year: 2025,
    location: "Creek Palace Residence, Dubai",
    image: "/projects/anil-residence-1.webp",
    gallery: [
      "/projects/anil-residence-1.webp",
      "/projects/anil-residence-2.webp",
      "/projects/anil-residence-3.webp",
    ],
    description:
      "Complete residential interior fit-out for a private villa at Creek Palace. A bright, contemporary composition in soft neutrals — bouclé upholstery, layered carpets, and floor-to-ceiling glazing framing the Marina skyline.",
    scope: [
      "Turnkey Interior Fit-Out",
      "Custom Sofas & Upholstery",
      "Flooring & Bespoke Rugs",
      "Window Treatments",
      "Styling & Photography",
    ],
  },
];

export const PORTFOLIO_CATEGORIES = [
  "All",
  "Living",
  "Majlis",
  "Office",
  "Commercial",
  "Joinery",
  "Holiday Home",
];

export const STATS = [
  { value: "1993", label: "Established" },
  { value: "2,300+", label: "Projects Delivered" },
  { value: "In-House", label: "Joinery · Upholstery · Curtains" },
  { value: "100%", label: "Turnkey Accountability" },
];

// ============================================
// SERVICE CATEGORIES (grouped for marketing view)
// ============================================
export const SERVICE_CATEGORIES = [
  {
    key: "core-works",
    iconName: "Hammer",
    title: "Core Works",
    tagline: "The structural backbone of every project.",
    oneLine: "Turnkey fit-out, civil works, renovation and demolition.",
    count: 4,
    image: "/media/owner-projects/time-furniture-site-fit-out-team-time-furniture.webp",
    imageAlt:
      "Time Furniture team working on an interior fit-out",
  },
  {
    key: "technical",
    iconName: "Zap",
    title: "Technical Services",
    tagline: "Systems engineered to disappear.",
    oneLine: "MEP, architectural lighting and smart home automation.",
    count: 3,
    image: "/media/team-projects/time-furniture-mep-first-fix-site-coordination.webp",
    imageAlt:
      "Time Furniture team coordinating ceiling services during an interior fit-out",
  },
  {
    key: "interior-finishing",
    iconName: "Sparkles",
    title: "Interior & Finishing",
    tagline: "The final layer of luxury.",
    oneLine: "Custom joinery, furniture, in-house upholstery, curtains, flooring and carpets.",
    count: 6,
    image: "/media/owner-projects/jumeirah-islands-villa-living-room-custom-sofas-time-furniture.webp",
    imageAlt:
      "Custom sofas and finishing by Time Furniture in a Jumeirah Islands villa living room",
  },
];

// ============================================
// CLIENT LOGOS (real brand marks)
// ============================================
export const CLIENT_LOGOS = [
  { name: "Emaar", src: "/logos/emaar.webp" },
  { name: "Nakheel", src: "/logos/nakheel.webp" },
  { name: "Aldar", src: "/logos/aldar.webp" },
  { name: "Majid Al Futtaim", src: "/logos/majid-al-futtaim.webp" },
  { name: "Address Hotels", src: "/logos/address.webp" },
  { name: "Shurooq", src: "/logos/shurooq.webp" },
  { name: "twofour54", src: "/logos/twofour54.webp" },
  { name: "Bottega Veneta", src: "/logos/bottega.webp" },
  { name: "Intermass", src: "/logos/intermass.webp" },
  { name: "Ginco General Contracting", src: "/logos/ginco.webp" },
];

export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/cdfdcf50-5487-40d6-9821-1e1ade15f104/images/48774627eedc42877736be181a4c298df69c3f724a4718d167e511f8c4d513be.png";

export const HERITAGE_IMAGE = "/media/revision-oct6/time-furniture-upholstery-craftsman-clean-workshop.webp";

// ============================================
// HOLIDAY HOME PACKAGES (DTCM-compliant)
// ============================================
export const HOLIDAY_HERO =
  "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1800&q=80";

export const PACKAGE_PROCESS = [
  { n: "01", t: "Property Inspection & Measurements", d: "Initial site visit to capture every dimension and existing condition." },
  { n: "02", t: "Design & Concept", d: "A tailored mood board and layout matched to your rental strategy." },
  { n: "03", t: "Procurement & Delivery", d: "We handle contractors, payments, move-in permits and delivery co-ordination." },
  { n: "04", t: "Install, Style & Staging", d: "Wallpapers, curtains, art, lighting — plus DTCM inventory check & styling." },
  { n: "05", t: "Deep Clean & Photoshoot", d: "Professional clean, hotel-grade bedding setup, and rental-ready photoshoot." },
];

export const PACKAGES = [
  {
    key: "affordable",
    name: "Affordable",
    tagline: "Essentials, done right.",
    fit: "STU · 1BR · 2BR",
    image: "/holiday-home-affordable-timefurniture.webp",
    imageAlt:
      "Affordable holiday home furnishing package Dubai UAE – budget interior setup by Time Furniture",
    highlights: ["Smart TV 43–50″", "Blackout bedroom curtains", "Hotel-grade linen", "DTCM safety kit"],
    inclusions: {
      "Living": ["3-seater sofa", "Armchair", "Coffee table", "Dining set", "TV unit", "Wall art set", "Mirror", "Artificial plant", "Large rug", "Decoration set"],
      "Bedroom": ["King bed", "2× bedside tables", "Dressing table & mirror", "Carpet", "2× table lamps", "Wall art set", "Decoration set"],
      "Electronics": ["Smart TV 43–50″", "Fridge", "Washing machine", "Cooker", "Microwave", "Kettle", "Toaster", "Vacuum cleaner", "Iron", "Hair dryer"],
      "DTCM Items": ["Hotel-grade linen per bedroom", "Safety box", "Fire extinguisher & blanket", "Alarm clock per bedroom", "Prayer mat & Qibla sign", "First aid kit"],
      "Curtains": ["Blackout set in bedroom", "Sheer curtains in living"],
      "Outdoor": ["Table + 2 chairs"],
      "Lighting": ["Chandelier in each room"],
      "Kitchenware & Household": ["Standard cookware, serveware, glassware", "Full household essentials"],
    },
  },
  {
    key: "standard",
    name: "Standard",
    tagline: "The balanced choice.",
    fit: "STU · 1BR · 2BR · 3BR",
    featured: true,
    image: "/holiday-home-standard-timefurniture.webp",
    imageAlt:
      "Standard holiday home interior package Dubai UAE – modern turnkey furnishing by Time Furniture",
    highlights: ["Smart TV 50–55″", "Custom bed & mattress", "Feature wall per room", "Optional dishwasher"],
    inclusions: {
      "Living": ["3-seater + 2-seater sofa", "Armchair", "Coffee + side table", "Dining set (4-seater)", "TV unit", "Floor lamp", "Custom wall art", "Mirror", "Plant with pot", "Large rug", "Decoration set"],
      "Bedroom": ["Custom king bed", "Custom mattress", "2× bedside tables", "Dressing table & mirror", "Carpet", "2× table lamps", "Custom wall art", "Decoration set"],
      "Electronics": ["Smart TV 50–55″", "Fridge", "Washing machine", "Dishwasher (optional)", "Cooker", "Microwave", "Kettle", "Toaster", "Vacuum cleaner", "Iron", "Hair dryer"],
      "DTCM Items": ["Hotel-grade linen per bedroom", "Safety box", "Fire extinguisher & blanket", "Alarm clock per bedroom", "Prayer mat & Qibla sign", "First aid kit"],
      "Curtains": ["Standard curtains in each room"],
      "Wallpapers": ["Feature wall in each room"],
      "Outdoor": ["Table + 2 chairs"],
      "Lighting": ["Chandelier in each room"],
      "Kitchenware & Household": ["Standard cookware, serveware, glassware", "Full household essentials"],
    },
  },
  {
    key: "premium",
    name: "Premium",
    tagline: "Editorial, elevated.",
    benefit: "Designed to maximize rental income and guest experience.",
    fit: "Apartments · Villas · Townhouses",
    image: "/holiday-home-premium-timefurniture.webp",
    imageAlt:
      "Premium luxury holiday home interior Dubai UAE – high-end turnkey furnishing by Time Furniture",
    highlights: ["Smart TV up to 85″", "Premium curtains & linens", "Balcony + swing + lounge set", "Coffee machine + dishwasher"],
    inclusions: {
      "Living": ["3-seater + 2-seater sofa", "Armchair", "Coffee + 2× side tables", "Dining set (4–6 seater)", "TV unit", "Floor lamp", "2× custom wall art", "Mirror", "2× table lamps", "2× artificial plants", "Large rug", "Decoration set"],
      "Bedroom": ["Custom king bed", "Custom mattress", "2× bedside tables", "Dressing table & mirror", "Side table", "Large carpet", "2× table lamps", "Custom wall art", "Decoration set"],
      "Electronics": ["Smart TV up to 85″", "Fridge", "Washing machine", "Dishwasher", "Cooker", "Coffee machine", "Microwave", "Kettle", "Toaster", "Vacuum cleaner", "Iron", "Hair dryer"],
      "DTCM Items": ["Hotel-grade linen per bedroom", "Safety box", "Fire extinguisher & blanket", "Alarm clock per bedroom", "Prayer mat & Qibla sign", "First aid kit"],
      "Curtains": ["Premium curtains in each room"],
      "Wallpapers": ["Feature wall in each room"],
      "Outdoor": ["Balcony set", "Swing chair", "Lounge set"],
      "Lighting": ["Chandelier in each room"],
      "Kitchenware & Household": ["Premium cookware, serveware, glassware", "Full household essentials"],
    },
  },
];

export const PACKAGE_PRICING = [
  { size: "Studio", code: "studio", from: 34500, to: 65000 },
  { size: "1 Bedroom", code: "1br", from: 39500, to: 88000 },
  { size: "2 Bedrooms", code: "2br", from: 54000, to: 108000 },
  { size: "3 Bedrooms", code: "3br", from: 77500, to: 145000 },
  { size: "Villa / Townhouse", code: "villa", from: null, to: null, note: "Custom quote" },
];

export const SERVICES_INCLUDED = [
  "Property inspection & measurements",
  "Design concept & material selection",
  "Contractor & supplier co-ordination",
  "Payment arrangements",
  "Delivery co-ordination",
  "Move-in permit acquisition",
  "Wallpaper, curtain, art & lighting installation",
  "Minor maintenance & supervision",
  "DTCM-standard inventory check",
  "Full deep clean & bedding setup",
  "Final styling & staging",
  "Professional photoshoot",
];
